<template>
  <div class="news-cnt">
    <div class="ty-banner-1">
      <img
        alt="河南万杰智能科技股份"
        src="@img/subpage-banner.jpg"
        title="河南万杰智能科技股份"
      />
    </div>
    <search-bar></search-bar>
    <div class="blk-main content clearafter">
      <div class="blk plc">
        <div class="p12-curmbs-1" navcrumbs="">
          <b>您的位置:</b>
          <router-link to="/">主页</router-link>
          &gt;
          <router-link to="/news/all">新闻动态</router-link>
          &gt;
          <router-link v-if="curType" :to="curType">{{
            curTypeName
          }}</router-link>
        </div>
      </div>
      <div class="clear"></div>
      <div class="blk-xs fl">
        <div class="fdh-01 blk">
          <div class="fdh-01-tit"><h3>新闻动态</h3></div>
          <div class="fdh-01-nav">
            <div
              class="fdh-01-nav-one"
              v-for="(newType, index) in newsTypes"
              :key="index"
            >
              <h3 :class="curType == newType.pyname ? 'nav-active' : ''">
                <router-link :to="newType.path">{{ newType.name }}</router-link>
              </h3>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="blk-sm fr">
        <div class="lb-3n-ts-03 b">
          <h3 class="lb-3n-ts-03-tit">
            <span>{{ curTypeName || "新闻中心" }}</span>
          </h3>
          <div class="zxlb-1n-ts-01-list" v-if="curType != 'sbczsp'">
            <dl v-for="(item, index) in news" :key="index">
              <dt>
                <router-link
                  :to="item.classifyid | findpy(newsTypes, item.id)"
                  target="_blank"
                  ><img
                    :alt="item.title"
                    :src="item.article_img"
                    :title="item.title"
                /></router-link>
              </dt>
              <dd>
                <h4>
                  <router-link
                    :to="item.classifyid | findpy(newsTypes, item.id)"
                    target="_blank"
                    :title="item.title"
                    >{{ item.title }}</router-link
                  >
                </h4>
                <div class="zxlb-1n-ts-01-list-desc">{{ item.introduce }}</div>
                <div class="zxlb-1n-ts-01-list-deta">
                  <router-link
                    :to="item.classifyid | findpy(newsTypes, item.id)"
                    target="_blank"
                    :title="item.title"
                    >了解详情</router-link
                  >
                </div>
              </dd>
            </dl>
          </div>
          <div class="video-list" v-else>
            <dl v-for="(item, index) in news" :key="index">
              <dt @click="showVideo(item.video_audio, item.article_img)">
                <img
                  :alt="item.title"
                  :src="item.article_img"
                  :title="item.title"
                />
                <div class="hover"><img src="@img/icon-play.png" alt="" /></div>
              </dt>
              <dd @click="showVideo(item.video_audio, item.article_img)">
                {{ item.title }}
              </dd>
            </dl>
          </div>
        </div>
        <div class="clear"></div>
        <div class="fenye">
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            layout="total, prev, pager, next, jumper"
            :page-sizes="[9, 18, 27]"
            :hide-on-single-page="total < listQuery.limit"
            @pagination="article_list"
          />
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 视屏弹出 -->
    <div class="pop-video" v-show="videoPlay">
      <div class="mask" @click="hideVideo"></div>
      <div class="inner">
        <!-- <div class="close"><img src="" alt="" /></div> -->
        <div id="video-cnt"></div>
      </div>
    </div>
  </div>
</template>

<script>
import searchBar from "../common/searchBar.vue";
import utils from "@/api/to_py.js";
import Pagination from "@/components/common/pagination";
import Player from "xgplayer";
export default {
  data() {
    return {
      newsTypes: [
        { name: "公司新闻", id: 15, path: "/news/gsxw", pyname: "gsxw" },
        { name: "行业动态", id: 14, path: "/news/xydt", pyname: "xydt" },
        { name: "设备操作视频", id: 26, path: "/news/sbczsp", pyname: "sbczsp" }
      ],
      curType: null,
      curTypeName: null,
      news: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 9
      },
      videoPlay: false,
      player: null
    };
  },
  components: {
    searchBar,
    Pagination
  },
  mounted() {
    this.urlFindId();
    this.curType = this.$route.params.name;
  },
  watch: {
    $route(to, from) {
      this.urlFindId();
    }
  },
  methods: {
    hideVideo() {
      this.videoPlay = false;
      this.player.destroy();
    },
    showVideo(src, postImg) {
      this.videoPlay = true;
      this.player = new Player({
        id: "video-cnt",
        url: this.$imgBaseUrl + src,
        poster: postImg,
        fluid: true
      });
    },
    urlFindId() {
      // console.log(this.$route.params);
      this.curType = this.$route.params.name;
      if (this.curType != "all") {
        this.newsTypes.forEach(element => {
          if (this.curType == utils.ConvertPinyin(element.name)) {
            this.curTypeId = element.id;
            this.curTypeName = element.name;
          }
        });
      } else {
        this.curTypeId = null;
        this.curTypeName = null;
      }
      this.article_list();
    },
    article_list: function() {
      this.$post("/Article/article_list", {
        classifyid: this.curTypeId ? this.curTypeId : "15,14",
        page: this.listQuery.page,
        limit: this.listQuery.limit
      }).then(response => {
        // console.log(response.data);
        this.news = response.data || [];
        this.total = response.count;
      });
    }
  },
  filters: {
    findpy(id, arrs, idd) {
      var baseurl = "/newsdetail/";
      arrs.forEach(element => {
        if (element.id == id) {
          baseurl += utils.ConvertPinyin(element.name) + "/0" + idd + ".html";
          return;
        }
      });
      return baseurl;
    }
  }
};
</script>

<style lang="less">
@import "~@css/warp.less";
.news-cnt {
  background: rgba(247, 247, 247, 1);
  padding-bottom: 200px;

  .pop-video {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .mask {
      background: rgba(0, 0, 0, 0.3);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    .inner {
      width: 50%;
      max-height: 60vh;
      margin: 0 auto;
      .close {
        text-align: right;
        img {
          width: 20px;
          height: 20px;
          background: #ffffff;
        }
      }
      #video-cnt {
        width: 90% !important;
      }
    }
  }

  .zxlb-1n-ts-01-list {
    dl {
      border: 1px solid rgba(223, 223, 223, 1);
      width: 100%;
      margin-bottom: 15px;
      padding: 22px 0 22px;
      background: #fff;
      display: inline-block;
      &:hover {
        border-color: rgba(19, 181, 179, 1);
        h4 a {
          color: rgba(19, 181, 179, 1);
        }
        .zxlb-1n-ts-01-list-deta {
          background: rgba(19, 181, 179, 1);
          border-color: rgba(19, 181, 179, 1);
        }
        .zxlb-1n-ts-01-list-deta a {
          color: #fff;
        }
      }
    }
    dt {
      width: 30%;
      height: 200px;
      overflow: hidden;
      float: left;
      margin-left: 22px;
      margin-right: 5.5%;
      img {
        width: 100%;
        margin: 0 auto;
        display: block;
      }
    }
    dd {
      width: 54%;
      float: left;
      h4 {
        height: 40px;
        font-weight: bold;
        font-size: 19px;
        color: rgba(75, 74, 74, 1);
        line-height: 40px;
        margin-bottom: 5px;
        a {
          display: block;
          color: rgba(75, 74, 74, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .zxlb-1n-ts-01-list-desc {
        max-height: 96px;
        font-size: 15px;
        line-height: 24px;
        color: rgba(121, 121, 121, 1);
        margin-bottom: 15px;
        overflow: hidden;
      }
      .zxlb-1n-ts-01-list-deta {
        float: right;
        width: 134px;
        height: 40px;
        display: inline-block;
        border: 1px solid rgba(172, 172, 172, 1);
        font-size: 15px;
        line-height: 40px;
        text-align: center;
        color: rgba(121, 121, 121, 1);
      }
    }
  }

  .video-list {
    dl {
      width: 32%;
      float: left;
      background: #f0f0f0;
      margin: 0 2% 13px 0;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
    dt {
      border: solid 1px rgba(236, 236, 236, 1);
      padding: 10px 9px;
      background: #fff;
      overflow: hidden;
      position: relative;

      img {
        margin: 0 auto;
        display: block;
        width: 100%;
        height: 200px;
      }
      .hover {
        cursor: pointer;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 50px;
          height: 50px;
        }
      }
    }
    dd {
      height: 50px;
      font-size: 14px;
      line-height: 50px;
      text-align: center;
      padding: 0 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      background: #f0f0f0;
      background-color: rgba(240, 240, 240, 1);
      a {
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news/index.vue